import { DialogConfig } from '../shared/types';

export const DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'startTrial',
	dialogId: 'free-to-standard-refresh',
	dialogType: 'modal',
};
